import axios from 'axios';
import { CalculationStatus } from 'views/planning-prognosis/types/calculation-status.type';

// GET
// /ewosapi/v1/planandprognosis/company/{globalCompanyId}/site/{localSiteId}/calculationstatus
export const getSiteCalculationStatus = async (
  globalCompanyId: string,
  localSiteId: string
): Promise<CalculationStatus> => {
  const res = await axios.get<CalculationStatus>(
    `/ewosapi/v1/planandprognosis/company/${globalCompanyId}/site/${localSiteId}/calculationstatus`
  );
  return res.data;
};
